var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('NavbarStyleTwo'),_c('Banner'),_c('AboutVenue'),_c('Carousel'),_c('Industry'),_c('Application'),_c('LivingSpace'),_c('News'),_c('Partner'),_c('FooterTop'),_c('BacktopButton')],1)}
var staticRenderFns = []

export { render, staticRenderFns }